import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d5de513"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "course-side" }
const _hoisted_2 = {
  key: 0,
  class: "lp-card course-side__card"
}
const _hoisted_3 = { class: "lp-card-title" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "course-side__play" }
const _hoisted_6 = { class: "course-side__meta" }
const _hoisted_7 = { class: "course-side__name" }
const _hoisted_8 = { class: "course-side__sub" }
const _hoisted_9 = { class: "lp-card course-side__card" }
const _hoisted_10 = { class: "lp-card-title" }
const _hoisted_11 = { class: "course-side__summary" }
const _hoisted_12 = { class: "lp-ring course-side__ring" }
const _hoisted_13 = {
  viewBox: "0 0 88 88",
  "aria-hidden": "true"
}
const _hoisted_14 = ["stroke-dashoffset"]
const _hoisted_15 = { class: "lp-ring__label" }
const _hoisted_16 = ["title"]
const _hoisted_17 = { class: "course-side__legend" }
const _hoisted_18 = { class: "course-side__legend--completed" }
const _hoisted_19 = { class: "course-side__legend--in_progress" }
const _hoisted_20 = {
  key: 1,
  class: "lp-card course-side__card"
}
const _hoisted_21 = { class: "lp-card-title" }
const _hoisted_22 = { class: "course-side__cert" }
const _hoisted_23 = { class: "course-side__cert-icon" }
const _hoisted_24 = {
  key: 1,
  class: "lp-btn lp-btn--outline lp-btn--block",
  "aria-disabled": "true"
}

import { computed } from 'vue';
import HcIcon from '@/modern/components/ui/HcIcon.vue';
import { FALLBACK_IMAGE, ICourse, ICourseModule, useCourseI18n } from './course';


export default /*#__PURE__*/_defineComponent({
  props: {
    course: null,
    currentModule: null,
    lessonsDone: null,
    lessonsTotal: null,
    modulesDone: null
  },
  setup(__props: any) {

const props = __props as {
  course: ICourse
  currentModule: ICourseModule | null
  lessonsDone: number
  lessonsTotal: number
  modulesDone: number
}



const { tc } = useCourseI18n();

const RADIUS = 38;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const percent = computed(() => props.lessonsTotal ? Math.round((props.lessonsDone / props.lessonsTotal) * 100) : 0);
const currentNumber = computed(() => props.currentModule ? props.course.modules.indexOf(props.currentModule) + 1 : 0);
const modulesLeft = computed(() => props.course.modules.length - props.modulesDone);
const certificateReady = computed(() => props.course.user_status === 'completed');

// Uma barrinha por módulo só enquanto couber; cursos muito longos ficam só com o anel
const showSegments = computed(() => props.course.modules.length > 1 && props.course.modules.length <= 16);

const lessonsLabel = (count: number) => count === 1 ? tc('lesson_count') : tc('lessons_count', { n: count });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    (__props.currentModule)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(tc)('resume_title')), 1),
          _createVNode(_component_router_link, {
            to: { name: 'training-module-show', params: { id: __props.currentModule.id } },
            class: "course-side__thumb"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: __props.currentModule.image_url || _unref(FALLBACK_IMAGE),
                alt: __props.currentModule.title
              }, null, 8, _hoisted_4),
              _createElementVNode("span", _hoisted_5, [
                _createElementVNode("span", null, [
                  _createVNode(HcIcon, {
                    name: "play-solid",
                    size: 22
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(tc)('module_label', { n: _unref(currentNumber) })) + " · " + _toDisplayString(__props.currentModule.module_status === 'in_progress' ? _unref(tc)('status_doing') : _unref(tc)('status_todo')), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(__props.currentModule.title), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(lessonsLabel(__props.currentModule.lessons_count)), 1),
          _createVNode(_component_router_link, {
            to: { name: 'training-module-show', params: { id: __props.currentModule.id } },
            class: "lp-btn lp-btn--block"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.currentModule.module_status === 'in_progress' ? _unref(tc)('continue_module') : _unref(tc)('start_module')) + " ", 1),
              _createVNode(HcIcon, {
                name: "arrow",
                size: 16
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("h3", _hoisted_10, _toDisplayString(_unref(tc)('progress_title')), 1),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(), _createElementBlock("svg", _hoisted_13, [
            _createElementVNode("circle", {
              class: "lp-ring__track",
              cx: "44",
              cy: "44",
              r: RADIUS,
              "stroke-width": "8"
            }),
            _createElementVNode("circle", {
              class: "lp-ring__value",
              cx: "44",
              cy: "44",
              r: RADIUS,
              "stroke-width": "8",
              "stroke-dasharray": CIRCUMFERENCE,
              "stroke-dashoffset": CIRCUMFERENCE * (1 - _unref(percent) / 100)
            }, null, 8, _hoisted_14)
          ])),
          _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(percent)) + "%", 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, _toDisplayString(_unref(tc)('lessons_of', { done: __props.lessonsDone, total: __props.lessonsTotal })), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(tc)('modules_of', { done: __props.modulesDone, total: __props.course.modules.length })), 1)
        ])
      ]),
      (_unref(showSegments))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", {
              class: "course-side__segments",
              style: _normalizeStyle({ gridTemplateColumns: `repeat(${__props.course.modules.length}, 1fr)` })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.course.modules, (module) => {
                return (_openBlock(), _createElementBlock("i", {
                  key: module.id,
                  class: _normalizeClass(`course-side__segment--${module.module_status}`),
                  title: module.title
                }, null, 10, _hoisted_16))
              }), 128))
            ], 4),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(tc)('status_done')), 1),
              _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(tc)('status_doing')), 1),
              _createElementVNode("span", null, _toDisplayString(_unref(tc)('status_todo')), 1)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (__props.course.has_certificate)
      ? (_openBlock(), _createElementBlock("section", _hoisted_20, [
          _createElementVNode("h3", _hoisted_21, _toDisplayString(_unref(tc)('certificate')), 1),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, [
              _createVNode(HcIcon, {
                name: "award",
                size: 22
              })
            ]),
            _createElementVNode("p", null, _toDisplayString(_unref(certificateReady) ? _unref(tc)('cert_card_done') : _unref(tc)('cert_card_locked', { total: __props.course.modules.length })), 1)
          ]),
          (_unref(certificateReady))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/profile/certificate",
                class: "lp-btn lp-btn--block"
              }, {
                default: _withCtx(() => [
                  _createVNode(HcIcon, {
                    name: "award",
                    size: 16
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(tc)('view_certificate')), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_24, [
                _createVNode(HcIcon, {
                  name: "lock",
                  size: 16
                }),
                _createTextVNode(" " + _toDisplayString(_unref(modulesLeft) === 1 ? _unref(tc)('remaining_module') : _unref(tc)('remaining_modules', { n: _unref(modulesLeft) })), 1)
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})